import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageSquare } from 'lucide-react';
import { company } from '../mock';

export default function MobileCallBar() {
  return (
    <div className="mobile-callbar" data-testid="mobile-callbar">
      <a className="mcb-call" href={company.phoneHref} data-testid="mcb-call">
        <Phone size={18} /> Call Now
      </a>
      <Link className="mcb-msg" to="/contact" data-testid="mcb-message">
        <MessageSquare size={18} /> Message
      </Link>
    </div>
  );
}
